import React from 'react';
import Chart from 'react-apexcharts';

const PieChart = ({labels, series}) => {
  const options = {
    chart: {
      type: 'pie',
    },
    labels: labels,
    legend: {
        // position: 'bottom',
        // labels: {
        //     colors: '#FFFFFF' 
        //   }
        show: false
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        // legend: {
        //   position: 'bottom'
        // }
      }
    }]
  };


  return (
    <div className='flex flex-col  items-center'>
      <Chart options={options} series={series} type="pie" width="200" height={'200'} />
    </div>
  );
};

export default PieChart;
